export * from './emailController.service';
import { EmailControllerService } from './emailController.service';
export const APIS = [EmailControllerService];
